import React from "react";
import styled from "styled-components";
import { Card } from "semantic-ui-react";
import { DomUpdateHighlighter } from "../DomUpdateHighlighter";
import { FluidFormFields } from "../FormFields.component";
import { useInlineValidation, useUpdateChatOnFieldChange } from "../common";
import { SimpleFormClearButton } from "../SimpleFormClearButton";
export function FormPanel({ form, cards, onSubmit }) {
    useInlineValidation();
    useUpdateChatOnFieldChange();
    const submitButtonLabel = form.getAdditionalConfigValue("styleConfig", "submitButtonLabel") || "Submit";
    return (React.createElement("div", { className: "fluidForm-content fluid-form-fields pt-6 px-2", style: { height: '100%', overflowY: 'auto' } },
        React.createElement(DomUpdateHighlighter, null, cards.map((card, index) => (React.createElement(StyledCard, { key: index, className: "f-bg" },
            card.title && React.createElement(Card.Header, { className: "text-xl px-2 f-text" }, card.title),
            React.createElement(CardContent, null,
                React.createElement(FluidFormFields, { field: card.data, options: { hideTitle: true, useStructuredOutput: true, useInstantValidation: true, autoFocus: false } })))))),
        React.createElement("div", { className: "flex items-center gap-2 mx-2 mb-3" },
            React.createElement(SimpleFormClearButton, null),
            React.createElement("button", { type: "button", className: "px-3 py-2 md:px-4 fluid-button-primary text-white rounded-lg transition-colors", onClick: () => { onSubmit(form.getFormSubmission()); } }, submitButtonLabel))));
}
/**
 * Styles
**/
const StyledCard = styled(Card) `
  width: 100% !important;
  flex: 1;
  display: flex;
  flex-direction: column;
  border: none !important;
`;
const CardContent = styled(Card.Content) `
  flex: 1;
  overflow-y: auto;
  border: none !important;
`;
export default FormPanel;
